import React from 'react'

interface ActionMessageDialogContextType {
  otherScreen: any
  screenIndex: number
  setOtherScreen: (screen: any) => void
  trackPage: (
    buttonType: string,
    index: number,
    subscreen?: string,
    detail?: string,
  ) => void
}

const ActionMessageDialogContext =
  React.createContext<ActionMessageDialogContextType>({
    otherScreen: {},
    screenIndex: 0,
    setOtherScreen: (_screen: any) => {},
    trackPage: (
      _buttonType: string,
      _index: number,
      _subscreen?: string,
      _detail?: string,
    ) => {},
  })

export default ActionMessageDialogContext
